import * as types from './actionTypes';
import Image from '../../libs/models/Image';


function addGalleryImages(state,action){
    
    //const imagesToAdd = 

    const newImages = {
        ...state,
        images:[ ...state.images,action.imageFiles.map(imageFile => Image('galleryImage',imageFile.baseFilename,{'file':imageFile.url}))]
    }

    return newImages;

}

//TODO: add deletedImages
const initialState = {
    avatar: null,
    backgroundImage: null,
    headerImage: null,
    galleryImages: [],
    deletedImages: []
}

const imagesReducer = (state = initialState,action) => {

    switch(action.type){
        
        case types.UpdateBackgroundImage:
            console.log(action.imageFile)
            let deletedBackgroundImageToAppend = state.backgroundImage ? state.backgroundImage.baseFilename : null;
            //TODO: if background image is not local add to deleted
            return {
                ...state,
                backgroundImage:Image('backgroundImage',action.imageFile.baseFilename,{'file':action.imageFile.url},action.imageFile.file),
                deletedImages: deletedBackgroundImageToAppend ? [...state.deletedImages,state.backgroundImage.baseFilename] : state.deletedImages
            }

        case types.UpdateHeaderImage:
            let deletedImageToAppend = state.headerImage ? state.headerImage.baseFilename : null;
            //TODO: if header image is not local add to deleted    
            return {
                ...state,
                headerImage:Image('headerImage',action.imageFile.baseFilename,{'file':action.imageFile.url},action.imageFile.file),
                deletedImages: deletedImageToAppend ? [...state.deletedImages,state.headerImage.baseFilename] : state.deletedImages
            }

        case types.UpdateAvatarImage:
            //TODO: if avatar image is not local add to deleted  
            let deletedAvatarToAppend = state.avatar && state.avatar.isLocal ? state.backgroundImage.baseFilename : null;
            return {
                ...state,
                avatar:Image('avatar',action.imageFile.baseFilename,{'file':action.imageFile.url},action.imageFile.file),
                deletedImages: state?.avatar?.isLocal ? [...state.deletedImages,state.avatar?.baseFilename] : state.deletedImages
            }

        case types.AddGalleryImages:

            return {
                ...state,
                galleryImages:[ ...state.galleryImages,...action.imageFiles.map(imageFile => Image('galleryImage',imageFile.baseFilename,{'file':imageFile.url},imageFile.file))]
            }

        //TODO: think how to implement this case
        case types.UpdateGalleryImage:

            return {
                ...state
            }

        case types.RemoveGalleryImages:

            console.log(action)
            let filenamesToRemove = action.imageFilesToDelete.map(imageFile => imageFile.baseFilename);

            //TODO: populate deleted images
            return {
                ...state,
                galleryImages: state.galleryImages.filter(image => !filenamesToRemove.includes(image.baseFilename)),
                deletedImages: [...state.deletedImages,...filenamesToRemove]
            }


        default: 
            return state;
            
    }

}

export default imagesReducer;